import React from 'react';
import { Icons } from '@ohif/ui-next';

interface ButtonContentProps {
  hasPending: boolean;
  isFullyReviewed: boolean;
}

export default function ButtonContent({ hasPending, isFullyReviewed }: ButtonContentProps) {
  if (hasPending) {
    return (
      /* LoadingSpinner is the ONE icon that is not a bare svg spread: it bakes in
         `h-5 w-5 animate-spin` and CONCATENATES rather than merges
         (Icons/Sources/LoadingSpinner.tsx:4-8), so no size or animation class is passed here
         -- passing one ships both and leaves the result to stylesheet order. Harmless today
         only because the values happen to coincide. Same treatment as
         OrganReviewDialog.tsx:209-212. */
      <Icons.LoadingSpinner aria-hidden="true" />
    );
  }

  if (isFullyReviewed) {
    return (
      <Icons.StatusTracking
        aria-hidden="true"
        className="h-5 w-5"
      />
    );
  }

  return (
    <Icons.ToolDicomTagBrowser
      aria-hidden="true"
      className="h-5 w-5"
    />
  );
}
